import { useBrand } from 'hooks/useBrand'

// Decisão 47b (nota [CC][F-receita-codigo-acesso], conferência do Esquadro):
// os temas whitelabel (`src/styles/{aspaec,remederi,vikura}-theme.css`)
// recolorem por SUBSTRING de classe (`[class*="bg-primary"]` etc) — qualquer
// classe que contenha "primary" vira a cor da marca. A rampa `marketplace-*`
// não casa com esse seletor, então usá-la nas 3 marcas apagaria a cor delas.
// Por isso: Cannect usa `marketplace-*` (a própria cor #464F31 do protótipo,
// `tailwind-colors.ts:35-55`); as 3 whitelabel usam `primary-*` (recolorido
// pelo CSS de tema, `primary-900` já é o hex da Cannect em
// `brands.config.ts:74` — mesma base, mas SUBSTITUÍDA pela marca nas outras).
// Mapa único por `config.key`, não `if` espalhado pelos componentes.
export type RecipeBrandColors = {
  /** Cartão escuro da D1/D3. */
  dark: string
  /** Mesma cor do cartão escuro, como `text-*` (ex.: texto do pill branco "Ver receita"). */
  darkText: string
  /** CTA primário (pill verde). */
  cta: string
  /** Fundo claro de chip/ícone (badge ℞, ícones de resumo, selo Pix). */
  softBg: string
  /** Texto/ícone sobre `softBg`. */
  softText: string
  /** Link de texto (ajuda, "Alterar", etc). */
  link: string
}

const CANNECT_COLORS: RecipeBrandColors = {
  dark: 'bg-marketplace-main',
  darkText: 'text-marketplace-main',
  cta: 'bg-marketplace-800',
  softBg: 'bg-marketplace-200',
  softText: 'text-marketplace-800',
  link: 'text-marketplace-800'
}

const WHITELABEL_COLORS: RecipeBrandColors = {
  dark: 'bg-primary-900',
  darkText: 'text-primary-900',
  cta: 'bg-primary-700',
  softBg: 'bg-primary-50',
  softText: 'text-primary-700',
  link: 'text-primary-700'
}

export function useRecipeBrandColors(): RecipeBrandColors {
  const { config } = useBrand()
  return config.key === 'cannect' ? CANNECT_COLORS : WHITELABEL_COLORS
}
